import * as React from "react";

export default () => {
  return (
    <div>
      Ladda upp dokumentet som tillhör uppsägnigen om det finns ett sådant.
    </div>
  );
};
